import axios from 'axios';
import {
  GET_ALL_MEDICAL_RECORDS_SUCCESS,
  CREATE_MEDICAL_RECORD_SUCCESS,
  UPDATE_MEDICAL_RECORD_SUCCESS, // Ensure this is defined in your types.js
  DELETE_MEDICAL_RECORD_SUCCESS,
  MEDICAL_RECORD_ERROR,
  baseURL
} from './types';

// Helper function to get the token and set headers
const getAuthHeaders = (contentType = 'application/json') => {
  const token = localStorage.getItem('token');
  const config = {
    headers: {
      'Content-Type': contentType,
    },
  };

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
};


export const getAllMedicalRecords = (hospitalID) => async (dispatch) => {
    try {
      const url = `${baseURL}/api/appointmentDoctorMedicalRecords/getall`;
      const config = getAuthHeaders();
      // This endpoint seems to use POST to get all records
      const res = await axios.post(url, {hospitalID}, config); 
      
      const records = Array.isArray(res.data.data) ? res.data.data : [];
  
      dispatch({ type: GET_ALL_MEDICAL_RECORDS_SUCCESS, payload: records });
      
    } catch (err) {
      dispatch({ type: MEDICAL_RECORD_ERROR, payload: err.response?.data || { msg: 'An error occurred' } });
    }
  };

export const createMedicalRecord = (formData) => async (dispatch) => {
  try {
    const url = `${baseURL}/api/appointmentDoctorMedicalRecords/create`;
    const config = getAuthHeaders('multipart/form-data');

    const res = await axios.post(url, formData, config);
    dispatch({ type: CREATE_MEDICAL_RECORD_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: MEDICAL_RECORD_ERROR, payload: err.response?.data || { msg: 'An error occurred' } });
    throw err;
  }
};

// --- THIS IS THE ACTION YOU NEED TO ADD ---
/**
 * @desc    Update an existing medical record using PATCH
 * @param   formData  - A FormData object containing the record's ID and updated fields.
 */
export const updateMedicalRecord = (formData) => async (dispatch) => {
  try {
    const url = `${baseURL}/api/appointmentDoctorMedicalRecords/update`;
    // Use 'multipart/form-data' to allow for potential file uploads
    const config = getAuthHeaders('multipart/form-data');

    // Use axios.patch to match your Postman setup
    const res = await axios.patch(url, formData, config);
    
    // Dispatch the updated record to the reducer
    dispatch({ type: UPDATE_MEDICAL_RECORD_SUCCESS, payload: res.data });

  } catch (err) {
    dispatch({ 
      type: MEDICAL_RECORD_ERROR, 
      payload: err.response?.data || { msg: 'An error occurred while updating the record' } 
    });
    // Rethrow the error to be caught by the component for modal feedback
    throw err;
  }
};


export const deleteMedicalRecord = (id) => async (dispatch) => {
    try {
      const url = `${baseURL}/api/appointmentDoctorMedicalRecords/delete`;
      const config = getAuthHeaders('application/json');
      config.data = { id };
  
      await axios.delete(url, config);
  
      dispatch({ type: DELETE_MEDICAL_RECORD_SUCCESS, payload: id });
  
    } catch (err) {
      dispatch({
        type: MEDICAL_RECORD_ERROR,
        payload: err.response?.data || { msg: 'Failed to delete record' }
      });
      throw err;
    }
  };